import { AnalyticsBrowser } from '@segment/analytics-next';
import { SEGMENT_IO_ANALYTICS_KEY } from '../config';

export const TRACK_PAGE_CATEGORIES = {
    "PAGE_LOAD": "pageLoad"
}

export const EVENTS = {
    "SERVER_ERROR" : "Server Error",
    "CLIENT_ERROR" : "Client Error"
}

class Analytics {

    static loadAnaylticsModule() {
        try {
            const analytics:any = AnalyticsBrowser.load({ writeKey: SEGMENT_IO_ANALYTICS_KEY });
            window.analytics = analytics;
        } catch(err) {
            console.warn("Could not load analytics module");
        }
    }

    static identifyUser(id:string) {
        try {
            window.analytics.identify(id);
        } catch(err) {
            console.warn("Could not identify user");
        }
    }
    static trackPage(category:string, pageName: string) {
        try {
            window.analytics.page(category, pageName);
        } 
        catch(err) {
            console.warn("Could not track page " + pageName + " for category " + category);
        }
    }
    static trackEvent(event:string, properties: any) {
        try {
            window.analytics.track(event, properties);
        } 
        catch(err) {
            console.warn("Could not track event " + event);
        }
    }

}

export default Analytics;